import { ActionReducerMap, createReducer, on } from '@ngrx/store';

import * as AlgoliaSearchActions from './algolia-search.actions';
import { SearchSettingsModel } from './algolia-search.models';

export const ALGOLIA_SEARCH_FEATURE_KEY = 'algoliaSearch';

export interface AlgoliaSearchState {
  settings: SearchSettingsModel | null;
}

export const initialAlgoliaSearchState: AlgoliaSearchState = {
  settings: null,
};

export const settingsReducer = createReducer(
  initialAlgoliaSearchState.settings,
  on(AlgoliaSearchActions.loadAlgoliaSearchSettingsSuccess, (state, { settings }) => ({
    collection_relevance: settings['Collection-relevance'],
    datasource_relevance: settings['DataSource-relevance'],
    datasource_tableRelevance: settings['DataSourceTable-relevance'],
    definition_alphabetical: settings['Definition-alphabetical'],
    definition_relevance: settings['Definition-relevance'],
    organization_relevance: settings['Organization-relevance'],
    report_alphabetical: settings['Report-alphabetical'],
    report_alphabeticalDesc: settings['Report-alphabetical-desc'],
    report_lastEdited: settings['Report-last-edited'],
    report_relevance: settings['Report-relevance'],
    table_alphabetical: settings['Table-alphabetical'],
    table_relevance: settings['Table-relevance'],
    user_email: settings['User-email'],
    user_relevance: settings['User-relevance'],
    userGroup_relevance: settings['UserGroup-relevance'],
    ...(settings['global-search'] && {
      global_search: settings['global-search'],
    }),
  }))
);

export const reducer: ActionReducerMap<AlgoliaSearchState> = {
  settings: settingsReducer,
};
